<template>
  <div>
    <div class="gen-work">
      <Hero :backImg="require('../../assets/img/gen/work/hero.jpg')" :backImgSp="require('../../assets/img/gen/work/hero_sp.jpg')" alt="" title="クレハの仕事" text="企画・営業職種" />
      <div class="page-contents">
        <section class="department eigyo">
          <div class="photo">
            <picture>
              <source srcset="../../assets/img/gen/work/image01.jpg"
                        media="(min-width: 768px)">
              <source srcset="../../assets/img/gen/work/image01_sp.jpg"
                        media="(max-width: 767px)">
              <img src="../../assets/img/gen/work/image01.jpg" alt="">
            </picture>
          </div>
          <div class="text">
            <h4 class="department-title">
              <p>
                営業部門
              </p>
            </h4>
            <div class="cat-wrapper">
              <div class="cat">
                <h5 class="cat-title">
                  営業
                </h5>
                <p class="cat-catch">
                  製品の販売、既存製品の市場開拓
                </p>
                <p class="cat-text">
                  社内関連各部門や関係会社と連携して事業拡大の推進と利益の向上に取り組むとともに、新規事業の立ち上げ、既存事業の拡大のための製品企画・開発も行うなど、業務は多岐にわたる。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="department kansetu">
          <div class="photo">
            <picture>
              <source srcset="../../assets/img/gen/work/image02.jpg"
                        media="(min-width: 768px)">
              <source srcset="../../assets/img/gen/work/image02_sp.jpg"
                        media="(max-width: 767px)">
              <img src="../../assets/img/gen/work/image02.jpg" alt="">
            </picture>
          </div>
          <div class="text">
            <h4 class="department-title">
              <p>
                間接部門
              </p>
            </h4>
            <div class="cat-wrapper">
              <div class="cat">
                <h5 class="cat-title">
                  経営企画
                </h5>
                <p class="cat-catch">
                  経営戦略の立案と推進
                </p>
                <p class="cat-text">
                  社会に貢献する企業の経営基盤を構築するとともに、経営活動の効率的な運営を支える。経営理念・経営方針・経営戦略や中長期経営画計画の立案や推進、クレハグループの事業分野の策定、国内外の企業提携・合弁の基本方針の策定と企画・推進、予算編成方針の策定と予算管理、IR活動による企業価値の維持・向上などを行う。
                </p>
              </div>
              <div class="cat">
                <h5 class="cat-title">
                  人事
                </h5>
                <p class="cat-catch">
                  従業員の労働環境の整備、組織の編成
                </p>
                <p class="cat-text">
                  経営戦略を実現するために必要な人財の確保・育成や、従業員がより働きやすい会社の実現に取り組む。人事諸制度の企画・運営、適正な労働条件の設定や運用、採用・配置・異動・昇格・退職および組織編制、人財育成計画の立案、社内教育諸制度の推進、賃金や社会保険の手続き、福利厚生や保健衛生、社内・グループ報の企画・編集・発行などを行う。
                </p>
              </div>
              <div class="cat">
                <h5 class="cat-title">
                  経理・財務
                </h5>
                <p class="cat-catch">
                  企業の会計、資金の管理
                </p>
                <p class="cat-text">
                  適切な計数や資金の管理によって、事業計画の推進を支援。経理では、会計原則に従った正確かつ迅速な経理処理、グループ会社を含めた適正な決算報告、税務処理、資産管理などを行う。財務では、資金計画の策定、資金の安定的かつ経済的な調達、適正かつ効率的な運用、出納管理などを行う。
                </p>
              </div>
              <div class="cat">
                <h5 class="cat-title">
                  情報システム
                </h5>
                <p class="cat-catch">
                  IT活用による業務・経営の効率化
                </p>
                <p class="cat-text">
                  クレハグループの情報統括部門として、企業活動や経営効率化をITの立場で支える。高度化するIT活用のニーズに対応するため、情報・通信システムの基本方針を策定するとともに、社内およびグループ会社の関連部門や IT ベンダーと連携し、業務アプリケーション、情報・通信基盤、情報セキュリティ全般の企画・立案・導入推進、運用を行う。
                </p>
              </div>
              <div class="cat">
                <h5 class="cat-title">
                  調達・物流
                </h5>
                <p class="cat-catch">
                  原燃料や資材の調達、物流の管理
                </p>
                <p class="cat-text">
                  調達・物流活動により事業の安定的かつ効率的な運営を支援。製品を製造するための原料・燃料や設備・機器などの資材の購入、購入品の輸送時の安全管理・検収・保管管理・出荷、工事の発注や納期管理、購入・発注先の調査・選定などを行う。
                </p>
              </div>
              <div class="cat">
                <h5 class="cat-title">
                  CSR
                </h5>
                <p class="cat-catch">
                  環境や社会課題の解決に向けた活動
                </p>
                <p class="cat-text">
                  クレハグループ全体のCSR活動を推進する。<br />環境や社会の課題に対して世界の動きを正確に把握し、クレハグループが持続可能な社会の発展に貢献しながら、10年後、20年後も成長し続けるためには何をすべきかを考え、基本方針を策定するとともに、社内への教育、啓発の推進、社外への情報開示などを行う。また、輸出管理の法規制対応やそれに伴う教育、啓発を推進する。
                </p>
              </div>
              <div class="cat">
                <h5 class="cat-title">
                  法務
                </h5>
                <p class="cat-catch">
                  契約締結や法律事務
                </p>
                <p class="cat-text">
                  会社の権益を適正に確保するとともに、法的なリスクの予防に取り組む。企業活動の法的な検討、国内外の契約の条件設定や草案作成・審査、訴訟・仲裁等の法律手続き、弁護士との折衝、法律情報の収集、法遵守意識の社内啓蒙などを行う。
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
export default {
  name: 'GenWork',
  components: {
    Hero,
  },
}
</script>

<style lang="scss" scoped>
.page-contents {
  margin-top: 100px;
  @media print,screen and (max-width: 767px) {
    margin-top: 50px;
  }
}
.department-title {
  margin: 0;
  p {
    color: #fff;
    font-weight: bold;
    font-size: 38px;
    display: inline-block;
    position: relative;
    height: 80px;
    padding: 80px;
    margin-bottom: 0;
    @media print,screen and (max-width: 767px) {
      font-size: 20px;
      padding: 40px;
      height: 40px;
    }
    margin: 0;
    &:before {
      content: "";
      display: inline-block;
      position: absolute;
      border: 120px solid transparent;
      // border-right: 15px solid #000;
      width: 0;
      height: 0;
      top: 0;
      left: -135px;
      @media print,screen and (max-width: 767px) {
        border: 60px solid transparent;
        left: -75px;
      }
      //left: calc(-15px - 3em);
    }
    &:after {
      content: "";
      display: inline-block;
      position: absolute;
      border: 3em solid transparent;
      // border-right: 15px solid #fff;
      width: 0;
      height: 0;
      top: 0;
      right: 0;
    }
  }
}
.cat-title {
  margin: 1em 0 0.5em;
}
.cat-catch {
  margin: 1em 0;
}
.department.eigyo {
  display: flex;
  @media print,screen and (max-width: 767px) {
    display: block;
  }
  .department-title {
    @media print,screen and (max-width: 767px) {
      text-align: right;
    }
    p {
      background-color: #3fae00;
      @media print,screen and (min-width: 768px) {
        transform: translateX(-100px);
      }
      &:before {
        border-right: 15px solid #3fae00;
      }
      &:after {
        border-right: 15px solid #fff;
      }
    }
  }
  .cat-title {
    color: #3fae00;
  }
  .photo {
    width: 100%;
    max-width: 640px;
    @media print,screen and (max-width: 767px) {
      max-width: 70%;
    }
  }
  .text {
    padding: 50px 50px 0 50px;
    @media print,screen and (max-width: 767px) {
      padding: 0;
    }
  }
}
.department.kansetu {
  margin-top: 100px;
  position: relative;
  @media print,screen and (max-width: 767px) {
    padding-bottom: 24px;
  }
  .department-title {
    p {
      background-color: #00797f;
      @media print,screen and (min-width: 768px) {
        position: absolute;
        top: 300px;
      }
      &:before {
        border-left: 15px solid #00797f;
        // border-right: unset;
        // right: -15px;
        right: -135px;
        left: auto!important;
        @media print,screen and (max-width: 767px) {
          right: -75px;
        }
      }
      &:after {
        border-left: 15px solid #fff;
        // border-right: unset;
        right: auto!important;
        left: 0;
      }
    }
  }
  .cat-title {
    color: #00797f;
  }
  .photo {
    text-align: right;
    @media print,screen and (max-width: 767px) {
      text-align: right;
    }
    img {
      max-width: 840px;
      width: 100%;
      @media print,screen and (max-width: 767px) {
        max-width: 70%;
      }
    }
  }
  .cat-wrapper {
    @media print,screen and (min-width: 768px) {
      padding: 100px 0;
    }
  }
}
.text {
  margin: 0 auto;
  max-width: 840px;
  width: 100%;
  @media print,screen and (max-width: 767px) {
    width: 90%;
    margin: 0 auto;
    margin-top: -20%;
  }
}
.cat-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: top;
  max-width: 840px;
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
}
.cat {
  max-width: 388px;
  width: 100%;
  @media print,screen and (max-width: 767px) {
    max-width: 100%;
  }
}
.cat-title {
  font-weight: bold;
  font-size: 38px;
  margin-bottom: 0;
  @media print,screen and (max-width: 767px) {
    font-size: 23px;
  }
}
.cat-catch {
  font-size: 20px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 0.5em;
}
.cat-text {
  font-size: 15px;
  margin-top: 0;
}
</style>
